module.exports = __webpack_public_path__ + "static/loopconsis-c7e61543bf78a006ba3626c208633437.png";